var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1870_12572)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4835 18.1951C16.1625 18.1951 20.9097 11.2691 20.9097 5.26362C20.9097 5.06647 20.9097 4.8708 20.8959 4.67586C21.8194 4.03344 22.6164 3.2358 23.25 2.32313C22.3898 2.69086 21.4755 2.93202 20.5406 3.03834C21.525 2.47014 22.2621 1.57746 22.6152 0.524122C21.6883 1.05356 20.6751 1.42721 19.6183 1.6277C17.8312 -0.20208 14.8424 -0.290733 12.9414 1.43049C11.7167 2.54032 11.1957 4.19505 11.5764 5.77339C7.7825 5.58953 4.2474 3.8639 1.8508 1.0251C0.59845 3.10186 1.239 5.75764 3.31245 7.0912C2.5615 7.07015 1.82665 6.87542 1.17 6.52321V6.58088C1.17115 8.74406 2.7547 10.6067 4.9558 11.0353C4.2612 11.218 3.5321 11.2445 2.826 11.1127C3.44355 12.9647 5.2157 14.2331 7.23395 14.2697C5.563 15.5346 3.49875 16.2214 1.37355 16.2192C0.99865 16.2181 0.62375 16.197 0.25 16.1538C2.40855 17.4874 4.919 18.1951 7.4835 18.1918",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1870_12572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 18,
    fill: "white",
    transform: "translate(0.25 0.195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.b1e93d0c01a8bd5c0ed8714a59aa7433.svg";
export { ForwardRef as ReactComponent };